/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
import { call, all, put, takeLatest } from 'redux-saga/effects';
import * as Actions from './actions';
import * as cartActions from '../../services/Cart/actions';
import * as Constants from './Constants';
import { showLoader, hideLoader } from '../../components/common/Helpers/loader';
// import { logError, FE_API_ERROR, FE_API_JS_ERROR } from '../../services/loggerService';
import * as notificationActions from '../../components/common/NotificationBar/actions';
import * as shippingActions from '../ShippingInfo/actions';
import { DEFAULT_ERR_MSG } from './Constants';

import logger from '../../components/common/ErrorBoundary/logger_new';
import { isPreorder, getServiceUrlandE2eRequestId } from '../../components/common/Helpers/index';

export function* callErrorResponse(apiResponse, data) {
  let errorResponse = 'BACKEND_ERROR';
  if (apiResponse.data.errors && apiResponse.data.errors.length > 0 && apiResponse.data.errors[0].message) {
    errorResponse = apiResponse.data.errors[0].message;
  }
  yield put({
    type: 'NBS_ERROR',
    response: errorResponse,
  });
  if (data?.callback) {
    data.callback(false);
  }
  if (data?.showError) {
    const { errors } = apiResponse.data || {};
    const errorMsg = `<span id="nbsError">${errors?.[0]?.message || DEFAULT_ERR_MSG}</span>`;
    yield put(notificationActions.showErrorNotification(errorMsg, undefined, { error: { message: errorMsg }, response: apiResponse }));
  }
}

function* retriveCart({ data }) {
  // debugger;
  let errorReview = false;
  let serviceDetails = null;

  yield put({ type: Constants.SHOW_REVIEWORDER_API_ERROR, errorReview });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_REVIEW_ORDER_ERROR, response: false, errorMessage: null });
  try {
    const apiResponseCartDetail = yield call(cartActions.getCartDetails, { pageName: data });
    // debugger;
    if (
      apiResponseCartDetail &&
      ((apiResponseCartDetail.data && apiResponseCartDetail.data.errors) ||
        (apiResponseCartDetail.request && apiResponseCartDetail.request.status !== 200))
    ) {
      errorReview = true;
      serviceDetails = getServiceUrlandE2eRequestId('retriveCart reviewOrder', apiResponseCartDetail);
      yield put({ type: Constants.SHOW_REVIEWORDER_API_ERROR, errorReview, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_REVIEW_ORDER_ERROR, response: true, errorMessage: apiResponseCartDetail?.data?.errors[0]?.notifyMessage });
      if (apiResponseCartDetail.data && apiResponseCartDetail.data.errors) {
        // const errorLog = getErrorLogObj({
        //   note: 'from getROPageCart  '.concat(apiResponseCartDetail?.data?.errors?.message ? apiResponseCartDetail?.data?.errors?.message : ''),
        //   serviceUrl: apiResponseCartDetail?.config?.url,
        //   networkError: {
        //     error: apiResponseCartDetail,
        //     response: apiResponseCartDetail.data.errors || null,
        //   },
        // });
        // errorLog.e2erequestid = apiResponseCartDetail?.headers?.e2erequestid;
        // logger(errorLog);
        if (apiResponseCartDetail.data.loggerData)
          apiResponseCartDetail.data.loggerData.note = `getROPageCart ${apiResponseCartDetail?.data?.loggerData.note}`;
        logger(apiResponseCartDetail?.data?.loggerData);
      }
    } else if (apiResponseCartDetail && apiResponseCartDetail.data) {
      yield put({ type: Constants.GET_DATA_SUCCESS_GET_AGREEMENTS, response: apiResponseCartDetail.data });
    }
  } catch (error) {
    if (error && error.response) {
      errorReview = true;
      serviceDetails = {
        method: 'retriveCart reviewOrder',
      };

      yield put({ type: Constants.SHOW_REVIEWORDER_API_ERROR, errorReview, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_REVIEW_ORDER_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    // logError('getROPageCart', error, FE_API_JS_ERROR);
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* getAgreementDetails({ data }) {
  // debugger;
  let errorReview = false;
  let serviceDetails = null;
  yield put({ type: Constants.SHOW_REVIEWORDER_API_ERROR, errorReview });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_REVIEW_ORDER_ERROR, response: false, errorMessage: null });
  try {
    if (data === 'Y') {
      const validateCartApiResponse = yield call(cartActions.validateCartCall, data);
      if (validateCartApiResponse && validateCartApiResponse.data) {
        const apiResponse = yield call(Actions.getData, data);
        if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
          // debugger;
          yield put({ type: Constants.GET_DATA_SUCCESS_GET_AGREEMENTS, response: apiResponse.data });
          yield put({ type: 'API_LOADED', response: true });
        } else if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
          errorReview = true;
          serviceDetails = getServiceUrlandE2eRequestId('getAgreementDetails', apiResponse);
          yield put({ type: Constants.SHOW_REVIEWORDER_API_ERROR, errorReview, serviceinfo: serviceDetails });
          yield put({ type: Constants.CEF_REVIEW_ORDER_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
          if (apiResponse.data && apiResponse.data.errors) {
            if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getDataFromApi ${apiResponse?.data?.loggerData.note}`;
            logger(apiResponse?.data?.loggerData);
          }
        }
        if (!validateCartApiResponse.data.errors) {
          yield put({ type: Constants.VALIDATE_CART_SUCCESS, response: apiResponse.data });
        }
      }
    } else {
      const getDataApiResponse = yield call(Actions.getData, data);
      if (getDataApiResponse && getDataApiResponse.data && !getDataApiResponse.data.errors) {
        yield put({ type: Constants.GET_DATA_SUCCESS_GET_AGREEMENTS, response: getDataApiResponse.data });
        yield put({ type: 'API_LOADED', response: true });
      } else if (
        getDataApiResponse &&
        ((getDataApiResponse.data && getDataApiResponse.data.errors) || (getDataApiResponse.request && getDataApiResponse.request.status !== 200))
      ) {
        errorReview = true;
        serviceDetails = getServiceUrlandE2eRequestId('getAgreementDetails', getDataApiResponse);
        yield put({ type: Constants.SHOW_REVIEWORDER_API_ERROR, errorReview, serviceinfo: serviceDetails });
        yield put({ type: Constants.CEF_REVIEW_ORDER_ERROR, response: true, errorMessage: getDataApiResponse?.data?.errors[0]?.notifyMessage });
        if (getDataApiResponse.data && getDataApiResponse.data.errors) {
          if (getDataApiResponse.data.loggerData)
            getDataApiResponse.data.loggerData.note = `getDataFromApi ${getDataApiResponse?.data?.loggerData.note}`;
          logger(getDataApiResponse?.data?.loggerData);
        }
      }
    }
  } catch (error) {
    if (error && error.response) {
      errorReview = true;
      serviceDetails = {
        method: 'getAgreementDetails',
      };
      yield put({ type: Constants.SHOW_REVIEWORDER_API_ERROR, errorReview, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_REVIEW_ORDER_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    // logError('getDataFromApi', error, FE_API_JS_ERROR);
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* orderUpdateShipping({ data, homePhoneAdded }) {
  let errorShipping = false;
  let serviceDetails = null;
  yield put({ type: Constants.ERR_OCCURED, errorShipping });
  yield put({ type: Constants.CEF_REVIEW_ORDER_ERROR, response: false, errorMessage: null });
  const notifyErrorMessage = data.notifyMessage;
  showLoader();
  yield put(notificationActions.hideNotification());
  try {
    const apiResponse = yield call(shippingActions.updateAddress, data, homePhoneAdded);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      if (
        apiResponse.data.serviceHeader &&
        ((apiResponse.data.serviceHeader.statusMsg && apiResponse.data.serviceHeader.statusMsg === 'SUCCESS') ||
          (apiResponse.data.serviceHeader.statusCode && apiResponse.data.serviceHeader.statusCode === '00'))
      ) {
        yield put({ type: Constants.ORDERUPDATE_SHIPPING_ADDRESS_SUCCESS, response: apiResponse?.status });
        yield put({ type: Constants.ORDERUPDATE_ADRESS_SUUCESS });
        if (isPreorder()) {
          yield call(cartActions.getCartDetails, { pageName: data });
        }
      }
      hideLoader();
    } else if (apiResponse.data.errors && apiResponse.data.errors.length > 0) {
      // yield put({ type: Constants.ORDERUPDATE_SHIPPING_ADDRESS_SUCCESS, response: apiResponse?.data });
      hideLoader();
      serviceDetails = getServiceUrlandE2eRequestId('isInvalidAddressError', apiResponse);
      yield put({ type: 'INVALID_ADDRESS', isInvalidAddressError: true, response: apiResponse.data, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_REVIEW_ORDER_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
    } else if (apiResponse && apiResponse.request && apiResponse.request.status !== 200) {
      errorShipping = true;
      serviceDetails = getServiceUrlandE2eRequestId('isInvalidAddressError', apiResponse);
      yield put({ type: Constants.ORDERUPDATE_SHIPPING_ADDRESS_SUCCESS, response: apiResponse?.data });
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_REVIEW_ORDER_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
    } else {
      hideLoader();
      yield put(notificationActions.showErrorNotification(notifyErrorMessage));
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        yield put({ type: Constants.ORDERUPDATE_SHIPPING_ADDRESS_SUCCESS, response: apiResponse?.data });
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `updateShipping ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
      }
    }
  } catch (error) {
    if (error && error.response) {
      errorShipping = true;
      serviceDetails = {
        method: 'updateShipping',
      };

      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_REVIEW_ORDER_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    hideLoader();
  }
}

function* orderGetEnabledDevices({ data }) {
  // debugger;
  let errorShipping = false;
  let serviceDetails = null;
  yield put({ type: Constants.ERR_OCCURED, errorShipping });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_REVIEW_ORDER_ERROR, response: false, errorMessage: null });
  showLoader();
  try {
    const apiResponseFetchDevices = yield call(shippingActions.fetchDevices, data);
    // yield  delay(5000);
    if (apiResponseFetchDevices && apiResponseFetchDevices.data && !apiResponseFetchDevices.data.errors) {
      yield put({
        type: 'ORDER_FETCH_SMS_DEVICES_SUCCESS',
        response: {
          fetchSMSEnabledDevices: apiResponseFetchDevices.data.devices,
        },
        commonData: {
          securePinVerifyFormVisible: false,
          // showSecurePinModal: true,
          sendSMS: false,
          fetchSMSEnabledDevices: true,
        },
      });
      hideLoader();
      yield put({ type: Constants.ORDER_GET_DATA_SUCCESS, response: apiResponseFetchDevices.data });
      yield put({ type: Constants.ORDER_GET_ENABLED_DEVICES_SUCCESS, response: apiResponseFetchDevices.data });
      // yield invokeTagging('cpc-selected_plan');
    } else {
      if (
        apiResponseFetchDevices &&
        ((apiResponseFetchDevices.data && apiResponseFetchDevices.data.errors) ||
          (apiResponseFetchDevices.request && apiResponseFetchDevices.request.status !== 200))
      ) {
        errorShipping = true;
        serviceDetails = getServiceUrlandE2eRequestId('getAddons', apiResponseFetchDevices);

        if (apiResponseFetchDevices.data.loggerData)
          apiResponseFetchDevices.data.loggerData.note = `getEnabledDevices ${apiResponseFetchDevices?.data?.loggerData.note}`;
        logger(apiResponseFetchDevices?.data?.loggerData);

        hideLoader();
        yield put({ type: Constants.CEF_REVIEW_ORDER_ERROR, response: true, errorMessage: apiResponseFetchDevices?.data?.errors[0]?.notifyMessage });
      }
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
      // logError('getEnabledDevices', apiResponse.data.errors, FE_API_ERROR);
      // updating fefault selected option to redux
      //  yield put({ type: 'UPDATE_SAVE_SELECTED_OPTION', data: apiResponse.data.output.shippingInfo.filter((item) => (item.addedShippingOptionId === true)) });
    }
  } catch (errorFetchDevices) {
    if (errorFetchDevices && errorFetchDevices.response) {
      errorShipping = true;
      serviceDetails = {
        method: 'getEnabledDevices',
      };
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_REVIEW_ORDER_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    // logError('getEnabledDevices', error, FE_API_JS_ERROR);
    if (errorFetchDevices) {
      hideLoader();
    }
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

// for sending sms
function* orderSendSms({ data }) {
  let errorShipping = false;
  let serviceDetails = null;
  yield put({ type: Constants.ERR_OCCURED, errorShipping });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_REVIEW_ORDER_ERROR, response: false, errorMessage: null });
  showLoader();
  try {
    const apiResponse = yield call(shippingActions.sendSms, data);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      if (apiResponse.data.statusCode === 200) {
        // const securePinVerifyFormVisible = true;
      }
      yield put({
        type: 'ORDER_FETCH_SMS_DEVICES_SUCCESS',
        response: {
          sendSMS: apiResponse.data,
        },
        commonData: {
          securePinVerifyFormVisible: true,
        },
      });
      hideLoader();
      yield put({ type: Constants.ORDER_GET_SEND_SMS_SUCCESS, response: apiResponse.data });
    } else {
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        errorShipping = true;
        serviceDetails = getServiceUrlandE2eRequestId('sendSms', apiResponse);

        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `sendSms ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);

        hideLoader();
        yield put({ type: Constants.CEF_REVIEW_ORDER_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
      }
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
    }
  } catch (error) {
    if (error && error.response) {
      errorShipping = true;
      serviceDetails = {
        method: 'sendSms',
      };
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_REVIEW_ORDER_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    if (error) {
      hideLoader();
    }
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

// code validation
function* orderCodeValid(data) {
  yield put({ type: Constants.ASYNC_FETCH });
  showLoader();
  let serviceDetails = null;
  try {
    const apiResponse = yield call(shippingActions.pinValidation, data.MTN, data.otp);
    if (apiResponse && apiResponse.data && apiResponse.data.status === 'SUCCESS' && !apiResponse.data.errors) {
      yield put({
        type: 'ORDER_FETCH_SMS_DEVICES_SUCCESS',
        commonData: {
          showSecurePinModal: false,
          securePinVerifyFormVisible: false,
          fetchSMSEnabledDevices: false,
          sendSMS: false,
          shippingInfoComplete: true,
          shippingInfoFormVisible: true,
          AUTH_CODE_VERIFICATION_ERROR: null,
        },
      });
      hideLoader();
      yield call(orderGetEnabledDevices, data);
    } else {
      const authCodeError = apiResponse.data && apiResponse?.data?.statusDescription;
      yield put({
        type: 'ORDER_FETCH_SMS_DEVICES_SUCCESS',
        commonData: {
          showSecurePinModal: false,
          securePinVerifyFormVisible: true,
          fetchSMSEnabledDevices: false,
          sendSMS: false,
          shippingInfoComplete: false,
          shippingInfoFormVisible: true,
          securePinVerified: false,
          isMaxAttemptsExceeded: authCodeError && authCodeError.toLowerCase().indexOf('the authorization code you entered is incorrect') === -1,
          AUTH_CODE_VERIFICATION_ERROR: authCodeError,
        },
      });
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `codeValid ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
        hideLoader();
      }
      hideLoader();
      serviceDetails = getServiceUrlandE2eRequestId('from codeValid sagas', apiResponse);
      yield put({ type: 'ORDER_FETCH_SMS_DEVICES_ERROR', isInvalidOTP: true, response: apiResponse.data, serviceinfo: serviceDetails });
    }
  } catch (error) {
    serviceDetails = {
      method: 'codeValid',
    };
    yield put({ type: Constants.ERR_OCCURED, serviceinfo: serviceDetails });
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* orderCityAndState(data) {
  // debugger;
  showLoader();
  try {
    const apiResponse = yield call(shippingActions.getZipDetails, data);
    if (apiResponse && apiResponse.data && !apiResponse.data.errorMessage) {
      if (Object.keys(apiResponse.data).length === 0 || (apiResponse.data.errors && apiResponse.data.errors.length > 0)) {
        apiResponse.data = { errorMessage: 'Please Enter valid Zip Code ' };
        yield put({ type: 'ORDER_CITY_AND_STATE_SUCCESS', response: apiResponse.data });
      } else {
        yield put({ type: 'ORDER_CITY_AND_STATE_SUCCESS', response: apiResponse.data });
      }

      // yield delay(3000);
      hideLoader();
    } else {
      yield put({ type: 'ORDER_CITY_AND_STATE_SUCCESS', response: apiResponse.data });
      // logError('cityAndState', apiResponse.data.errorMessage, FE_API_ERROR);
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `cityAndState ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
        hideLoader();
      }
    }
  } catch (error) {
    yield put({ type: Constants.ERR_OCCURED });
    // logError('cityAndState', error, FE_API_JS_ERROR);
    if (error) {
      hideLoader();
    }
  }
}

function* getPromos() {
  yield put({ type: Constants.ASYNC_FETCH });
  showLoader();
  try {
    const apiResponse = yield call(Actions.getPromosFromAEM);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({ type: Constants.PROMOS_RESPONSE_RECEIVED, response: apiResponse.data });
      hideLoader();
    } else {
      // yield put({ type: Constants.PAGE_LOAD_API_ERROR });
      hideLoader();
      // logError('getNPANXX', apiResponse?.data?.errors, FE_API_ERROR);
      const errorLog = {
        json: true,
        eventType: 'FE_API_ERROR',
        message: 'GENERIC_ERROR_PAGE',
        note: 'from getPromos sagas',
        networkError: {
          error: apiResponse,
          response: apiResponse?.data?.errors || null,
        },
      };
      logger(errorLog);
    }
  } catch (error) {
    // yield put({ type: Constants.PAGE_LOAD_API_ERROR });
    hideLoader();
    // logError('getPromos', error, FE_API_JS_ERROR);
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* actionWatcher() {
  yield takeLatest(Constants.GET_AGREEMENT_DETAILS, getAgreementDetails);
  yield takeLatest(Constants.GET_CART_DETAILS, retriveCart);
  // yield takeLatest('GET_ORDER_NBS_API', getOrderNBSData);
  yield takeLatest(Constants.ORDERUPDATE_SHIPPING_ADDRESS, orderUpdateShipping);
  yield takeLatest(Constants.ORDER_GET_ENABLED_DEVICES, orderGetEnabledDevices);
  yield takeLatest(Constants.ORDER_GET_SEND_SMS, orderSendSms);
  yield takeLatest(Constants.ORDER_CODE_VALIDATION, orderCodeValid);
  yield takeLatest(Constants.ORDER_GET_ZIP_DETAILS_FROM_API, orderCityAndState);
  yield takeLatest('GET_PROMOS', getPromos);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
